import React from 'react';
import Footer from '../../components/Layout/Footer';
import SearchModal from '../../components/Layout/Header/SearchModal';
import ContactMain from './ContactMain';
import DetailsHeader from '../../components/Layout/Header/DetailsHeader';


const Contact = () => {
    return (
        <React.Fragment>
            {/* Header */}
            <DetailsHeader
                parentMenu='contact'
                activeMenu="/contact"
            />
            {/* Header */}

            {/* ContactMain Section Start */}
            <ContactMain />
            {/* ContactMain Section End */}

            {/* Footer */}
            <Footer />
            {/* Footer */}

            {/* SearchModal */}
            <SearchModal />
            {/* SearchModal */}
        </React.Fragment>

    );
}


export default Contact;